import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../../components/feature/SEOHead';
import ExercicioGratisNavbar from '../components/ExercicioGratisNavbar';
import LeadCaptureForm from '../components/LeadCaptureForm';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function EncantationsGratis() {
  const [encantation, setEncantation] = useState('');
  const [praticou, setPraticou] = useState(false);

  const handlePraticar = () => {
    if (encantation.trim()) {
      setPraticou(true);
      setTimeout(() => setPraticou(false), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50">
      <SEOHead
        title="Encantations Tony Robbins Grátis | Reprogramação Emocional — Carta do Eu Futuro"
        description="Experimente gratuitamente a técnica Encantations de Tony Robbins. Reprograme seu sistema nervoso com palavras, movimento e emoção para transformação pessoal imediata."
        keywords="encantations tony robbins, PNL grátis, reprogramação emocional, afirmações poderosas"
        canonical="/exercicio-gratis/encantations-tony-robbins"
      />
      <ExercicioGratisNavbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 px-6 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gold-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-gold-300 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-4xl mx-auto relative z-10">
          <div className="inline-block px-4 py-2 bg-gold-500/15 border border-gold-500/30 text-gold-400 rounded-full text-sm font-semibold mb-6 tracking-wide font-['Montserrat']">VERSÃO GRATUITA</div>
          <h1 className="font-['Playfair_Display'] text-5xl font-bold mb-6 leading-tight text-white">Encantations — Técnica Tony Robbins</h1>
          <p className="text-xl text-white/70 mb-8 leading-relaxed font-['Montserrat'] font-light">Reprograme seu sistema nervoso com palavras + movimento + emoção. Experimente uma versão simplificada desta técnica poderosa.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              { icon: 'ri-fire-line', title: 'Poderoso', desc: 'Transforma estado emocional' },
              { icon: 'ri-flashlight-line', title: 'Energizante', desc: 'Ativa corpo e mente' },
              { icon: 'ri-focus-3-line', title: 'Imediato', desc: 'Resultados instantâneos' },
            ].map((item) => (
              <div key={item.title} className="bg-white/8 backdrop-blur-sm rounded-xl p-4 border border-gold-500/20">
                <div className="w-10 h-10 flex items-center justify-center mb-2"><i className={`${item.icon} text-gold-400 text-2xl`}></i></div>
                <div className="font-semibold mb-1 text-white font-['Playfair_Display']">{item.title}</div>
                <div className="text-sm text-white/55 font-['Montserrat']">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* O que é */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">O que são Encantations?</h2>
          <p className="text-lg text-slate-700 leading-relaxed mb-6">Encantations são afirmações faladas em voz alta com movimento corporal intenso e emoção genuína. Diferente das afirmações tradicionais, elas envolvem todo o seu ser.</p>
          <p className="text-lg text-slate-700 leading-relaxed">Tony Robbins popularizou esta técnica que combina linguagem verbal, fisiologia corporal e estado emocional elevado para criar mudanças profundas e duradouras.</p>
        </div>
      </section>

      {/* Fundamentos */}
      <section className="py-16 px-6 bg-slate-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 mb-8">Fundamentos da Técnica</h2>
          <div className="space-y-6">
            {[
              { num: 1, title: 'Escolha sua Encantation', desc: 'Crie uma frase poderosa no presente que represente quem você quer ser.', ex: 'Ex: "Eu sou imparável e cheio de energia!", "Eu irradio confiança e amor!"' },
              { num: 2, title: 'Adicione Movimento', desc: 'Combine sua frase com movimentos corporais expansivos e energéticos.', ex: 'Braços abertos, pulos, socos no ar, postura de vitória — quanto mais intenso, melhor!' },
              { num: 3, title: 'Eleve a Emoção', desc: 'Sinta profundamente a emoção que você quer instalar. Não apenas fale — SINTA!', ex: 'A emoção genuína é o que programa seu sistema nervoso para a mudança.' },
            ].map((step) => (
              <div key={step.num} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-charcoal-800 to-charcoal-900 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">{step.num}</div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                    <p className="text-slate-700 mb-3">{step.desc}</p>
                    <p className="text-sm text-slate-500 italic">{step.ex}</p>
                  </div>
                </div>
              </div>
            ))}
            {/* Bloqueados */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/80 to-white z-10 flex items-center justify-center backdrop-blur-sm rounded-2xl">
                <div className="text-center p-8">
                  <div className="w-16 h-16 rounded-full bg-charcoal-100 flex items-center justify-center mx-auto mb-4"><i className="ri-lock-fill text-3xl text-charcoal-400"></i></div>
                  <h3 className="font-['Playfair_Display'] text-2xl font-bold text-charcoal-800 mb-2">Mais 5 passos na versão completa</h3>
                  <p className="text-charcoal-500 mb-6 font-['Montserrat']">Respiração, ritmo, ancoragem e muito mais</p>
                  <Link to="/planos#exercicios-pnl" className="inline-block px-8 py-3 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-semibold transition-all whitespace-nowrap font-['Montserrat']">Ver Versão Completa</Link>
                </div>
              </div>
              <div className="blur-sm pointer-events-none space-y-6">
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200">
                  <div className="flex items-start gap-4"><div className="w-12 h-12 rounded-full bg-slate-300 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">4</div><div><h3 className="text-xl font-bold text-slate-900 mb-2">Defina o Momento Ideal</h3><p className="text-slate-700">Escolha quando praticar para máximo impacto...</p></div></div>
                </div>
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200">
                  <div className="flex items-start gap-4"><div className="w-12 h-12 rounded-full bg-slate-300 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">5</div><div><h3 className="text-xl font-bold text-slate-900 mb-2">Técnicas de Respiração</h3><p className="text-slate-700">Potencialize com padrões respiratórios...</p></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mini Prática */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-orange-50 to-rose-50 rounded-3xl p-8 border-2 border-orange-200">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Mini Prática Gratuita</h2>
            <p className="text-slate-700 mb-8">Experimente criar sua primeira Encantation</p>
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-slate-900 mb-2">Crie sua Encantation</label>
                <textarea value={encantation} onChange={(e) => setEncantation(e.target.value)} maxLength={200} placeholder="Ex: Eu sou imparável e cheio de energia! Eu conquisto tudo que desejo!" className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-all resize-none" rows={4} />
                <div className="text-xs text-slate-500 mt-1">{encantation.length}/200 caracteres</div>
              </div>
              <button onClick={handlePraticar} disabled={!encantation.trim()} className={`w-full px-8 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${!encantation.trim() ? 'bg-slate-300 text-slate-500 cursor-not-allowed' : 'bg-gradient-to-r from-orange-600 to-rose-600 text-white hover:shadow-lg'}`}>
                {praticou ? 'Visualizado!' : 'Visualizar Encantation'}
              </button>
              {praticou && (
                <div className="p-6 bg-gradient-to-r from-orange-100 to-rose-100 rounded-xl border-2 border-orange-300">
                  <p className="text-lg font-bold text-orange-900 mb-2 text-center">&quot;{encantation}&quot;</p>
                  <p className="text-sm text-orange-700 text-center mt-4">Imagine dizendo isso com energia total, movimentos expansivos e emoção genuína!</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <LeadCaptureForm exercicioNome="Encantations (Tony Robbins)" />

      {/* CTA Final */}
      <section className="py-16 px-6 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-12 h-px bg-gold-500/30 mx-auto mb-8"></div>
          <h2 className="font-['Playfair_Display'] text-4xl font-bold mb-6 text-white">Pronto para reprogramar seu sistema nervoso?</h2>
          <p className="text-xl text-white/55 mb-8 font-['Montserrat'] font-light">Acesse a versão completa das Encantations com movimento, respiração e momento ideal.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/planos#exercicios-pnl" className="px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-bold text-sm hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] tracking-wide">Comprar por R$ 18</Link>
            <Link to="/planos#exercicios-pnl" className="px-10 py-4 bg-white/8 text-white rounded-full font-bold text-sm hover:bg-white/15 transition-all whitespace-nowrap border border-gold-500/20 font-['Montserrat'] tracking-wide">Pacote 6 Técnicas - R$ 47</Link>
          </div>
          <p className="text-sm text-white/30 mt-6 font-['Montserrat']">Acesso vitalício · Auto-save · Rastreamento</p>
        </div>
      </section>
    </div>
  );
}
